import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useImmerReducer } from "use-immer"
import { Page, Breadcrumb, ActorHero, ActorInfo, Card } from "../../components"
import { Accordion, Section } from "../../containers"

import Axios from "axios"
import { IMAGE_BASE_URL, API_URL, API_KEY, POSTER_SIZE } from "../../helpers/config"

function SingleActor() {
  const { id } = useParams()
  const NoImage = "https://i.ibb.co/bmkvfbv/No-image.jpg"
  const [isMovieActive, setIsMovieActive] = useState(true)
  const initialState = {
    movies: [
      {
        title: "",
        video: "",
        vote_average: "",
        overview: "",
        release_date: "",
        adult: false,
        backdrop_path: "",
        vote_count: "",
        genre_ids: [],
        id: "",
        original_language: "en",
        original_title: "",
        poster_path: "",
        popularity: "",
        character: "",
        credit_id: "",
        order: 0,
      },
    ],
    tvshows: [
      {
        backdrop_path: "",
        first_air_date: "",
        genre_ids: [],
        id: "",
        name: "",
        origin_country: [],
        original_language: "",
        original_name: "",
        overview: "",
        poster_path: "",
        vote_average: "",
        vote_count: "",
        popularity: "",
        character: "",
        credit_id: "",
        episode_count: "",
      },
    ],
    actor: {
      adult: "",
      also_known_as: [],
      biography: "",
      birthday: "",
      deathday: "",
      gender: "",
      homepage: "",
      id: "",
      imdb_id: "",
      known_for_department: "",
      name: "",
      place_of_birth: "",
      popularity: "",
      profile_path: "",
    },
    socialIds: {
      facebook_id: "",
      instagram_id: "",
      twitter_id: "",
    },
    findMovie: [],
    findTvShows: [],
    isFetching: true,
    searchTerm: "",
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadMovies":
        draft.movies = action.data
        return
      case "loadSearchMovies":
        draft.findMovie = action.data
        return
      case "loadTvShows":
        draft.tvshows = action.data
        return
      case "loadFindTvShows":
        draft.findTvShows = action.data
        return
      case "loadActorInfo":
        draft.actor = action.data
        return
      case "loadSocialIds":
        draft.socialIds = action.data
        return
      case "isFetching":
        draft.isFetching = action.value
        return
      case "searchTerm":
        draft.searchTerm = action.value
        return
      default:
        console.log("Defauult Actor")
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  const fetchActorInfo = async (ourRequest) => {
    dispatch({ type: "isFetching", value: true })
    try {
      let result = await Axios.get(`${API_URL}person/${id}?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (result) {
        dispatch({ type: "loadActorInfo", data: result.data })
        dispatch({ type: "isFetching", value: false })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMovies = async (ourRequest) => {
    dispatch({ type: "isFetching", value: true })
    try {
      let result = await Axios.get(`${API_URL}person/${id}/movie_credits?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (result) {
        dispatch({ type: "loadMovies", data: result.data.cast })
        dispatch({ type: "isFetching", value: false })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchTvShows = async (ourRequest) => {
    dispatch({ type: "isFetching", value: true })
    try {
      let result = await Axios.get(`${API_URL}person/${id}/tv_credits?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (result) {
        dispatch({ type: "loadTvShows", data: result.data.cast })
        dispatch({ type: "isFetching", value: false })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSocialIds = async (ourRequest) => {
    dispatch({ type: "isFetching", value: true })
    try {
      let result = await Axios.get(`${API_URL}person/${id}/external_ids?api_key=${API_KEY}`, { cancelToken: ourRequest.token })
      if (result) {
        dispatch({ type: "loadSocialIds", data: result.data })
        dispatch({ type: "isFetching", value: false })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const ourRequest = Axios.CancelToken.source()
    fetchActorInfo(ourRequest)
    fetchMovies(ourRequest)
    fetchTvShows(ourRequest)
    fetchSocialIds(ourRequest)

    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    if (state.searchTerm && isMovieActive) {
      let dataMovie = state.movies.filter((movie) => {
        if (movie.title.toLowerCase().includes(state.searchTerm.toLowerCase())) {
          return movie
        } else {
          return ""
        }
      })
      dispatch({ type: "loadSearchMovies", data: dataMovie })
    } else if (state.searchTerm) {
      let dataMovie = state.tvshows.filter((movie) => {
        if (movie.name.toLowerCase().includes(state.searchTerm.toLowerCase())) {
          return movie
        } else {
          return ""
        }
      })
      dispatch({ type: "loadFindTvShows", data: dataMovie })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.searchTerm])

  if (!state.actor && !state.movies && !state.tvshows) {
    return <p>Loading......</p>
  }

  return (
    <Page title={state.actor.name ? state.actor.name : "...."}>
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item title={state.actor.name ? state.actor.name : "...."} />
        </Breadcrumb.List>
      </Breadcrumb>

      <ActorHero>
        {state.actor && (
          <ActorHero.Wrapper>
            <ActorHero.Thumbnail src={`${IMAGE_BASE_URL}/t/p/w300_and_h450_bestv2${state.actor.profile_path}`} />
            <ActorHero.Content>
              <ActorHero.Name>{state.actor.name}</ActorHero.Name>
              <ActorHero.Subtitle>Biography</ActorHero.Subtitle>
              <ActorHero.Biography>{state.actor.biography ? state.actor.biography : "Not Available"}</ActorHero.Biography>
            </ActorHero.Content>
          </ActorHero.Wrapper>
        )}
      </ActorHero>

      <ActorInfo>
        <ActorInfo.Heading>Porsonal Info</ActorInfo.Heading>
        <ActorInfo.Content>
          <ActorInfo.ItemWrapper>
            <ActorInfo.Item>
              <ActorInfo.Title>Gender</ActorInfo.Title>
              <ActorInfo.Text>{state.actor.gender === 2 ? "Male" : "Female"}</ActorInfo.Text>
            </ActorInfo.Item>
            <ActorInfo.Item>
              <ActorInfo.Title>Birthday</ActorInfo.Title>
              <ActorInfo.Text>{state.actor.birthday ? state.actor.birthday : "Not Available"}</ActorInfo.Text>
            </ActorInfo.Item>
          </ActorInfo.ItemWrapper>
          <ActorInfo.ItemWrapper>
            <ActorInfo.Item>
              <ActorInfo.Title>Place of birth</ActorInfo.Title>
              <ActorInfo.Text>{state.actor.place_of_birth ? state.actor.place_of_birth : "Not Available"}</ActorInfo.Text>
            </ActorInfo.Item>
            <ActorInfo.Item>
              <ActorInfo.Title>Social Handle</ActorInfo.Title>
              {state.socialIds.instagram_id && <ActorInfo.SocialLink target="_blank" to={{ pathname: `https://instagram.com/${state.socialIds.instagram_id}` }} name="ph-instagram-logo" />}
              {state.socialIds.twitter_id && <ActorInfo.SocialLink target="_blank" to={{ pathname: `https://twitter.com/${state.socialIds.twitter_id}` }} name="ph-twitter-logo" />}
              {state.socialIds.facebook_id && <ActorInfo.SocialLink target="_blank" to={{ pathname: `https://facebook.com/${state.socialIds.facebook_id}` }} name="ph-facebook-logo" />}
            </ActorInfo.Item>
          </ActorInfo.ItemWrapper>
        </ActorInfo.Content>
      </ActorInfo>

      <Accordion>
        <Accordion.Header>
          <Accordion.Left>
            <Accordion.Tab onClick={() => setIsMovieActive(true)} active={isMovieActive}>
              Movies
            </Accordion.Tab>
            <Accordion.Tab onClick={() => setIsMovieActive(false)} active={!isMovieActive}>
              Tv Shows
            </Accordion.Tab>
            <Accordion.Tab>
              <Section.Count>{isMovieActive ? state.movies.length : state.tvshows.length}</Section.Count>
            </Accordion.Tab>
          </Accordion.Left>
          <Accordion.Right>
            <Accordion.Search onChange={(e) => dispatch({ type: "searchTerm", value: e.target.value })} />
          </Accordion.Right>
        </Accordion.Header>
        <Accordion.Body>
          {isMovieActive &&
            Boolean(!state.searchTerm) &&
            Boolean(state.movies.length) &&
            state.movies.map((movie, index) => {
              return (
                <Card key={index} to={`/movie/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : NoImage} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.title}</Card.Title>
                    <Card.Date>{movie.release_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
          {isMovieActive &&
            Boolean(state.searchTerm) &&
            Boolean(state.findMovie.length) &&
            state.findMovie.map((movie) => {
              return (
                <Card key={movie.id} to={`/movie/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : NoImage} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.title}</Card.Title>
                    <Card.Date>{movie.release_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}

          {!isMovieActive &&
            Boolean(!state.searchTerm) &&
            Boolean(state.tvshows.length) &&
            state.tvshows.map((movie, index) => {
              return (
                <Card key={index} to={`/tv/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : NoImage} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.name}</Card.Title>
                    <Card.Date>{movie.first_air_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
          {!isMovieActive &&
            Boolean(state.findTvShows.length) &&
            state.findTvShows.map((movie, index) => {
              return (
                <Card key={index} to={`/tv/${movie.id}`}>
                  <Card.Thumb rate={movie.vote_average}>
                    <Card.Rating rate={movie.vote_average} />
                    <Card.Image path={movie.poster_path ? `${IMAGE_BASE_URL}${POSTER_SIZE}${movie.poster_path}` : NoImage} />
                  </Card.Thumb>
                  <Card.Info>
                    <Card.Title>{movie.name}</Card.Title>
                    <Card.Date>{movie.first_air_date}</Card.Date>
                  </Card.Info>
                </Card>
              )
            })}
        </Accordion.Body>
        {isMovieActive && Boolean(!state.movies.length) && (
          <Accordion.NoDataFound>
            <Accordion.NotFoundText>No data Available Yet.</Accordion.NotFoundText>
          </Accordion.NoDataFound>
        )}
        {!isMovieActive && Boolean(!state.tvshows.length) && (
          <Accordion.NoDataFound>
            <Accordion.NotFoundText>No data Available Yet.</Accordion.NotFoundText>
          </Accordion.NoDataFound>
        )}
        {state.searchTerm && Boolean(!state.findMovie.length) && Boolean(!state.findTvShows.length) && (
          <Accordion.ErrorBody>
            {isMovieActive && state.searchTerm && Boolean(!state.findMovie.length) && <Accordion.NotFoundText>Sorry, we couldn't Movies find any matches for "{state.searchTerm}"</Accordion.NotFoundText>}
            {!isMovieActive && state.searchTerm && Boolean(!state.findTvShows.length) && <Accordion.NotFoundText>Sorry, we couldn't Tv-shows find any matches for "{state.searchTerm}"</Accordion.NotFoundText>}
          </Accordion.ErrorBody>
        )}
      </Accordion>
    </Page>
  )
}

export default SingleActor
